__turbopack_context__.v({
  "blogPostTag": "X7IHjG_blogPostTag",
  "blogPostTagWrapper": "X7IHjG_blogPostTagWrapper",
});
